import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Card,
  Typography,
  IconButton,
  Tooltip,
  // Divider,
  // Button,
} from "@common-ui/ui";

import { useFormik } from "formik";
import * as Yup from "yup";

import throttle from "lodash/throttle";
import { useDispatch, useSelector } from "react-redux";
// import Address from "./Address";
import { AddCircle, DeleteForever } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { setGroup, setGroups } from "../../actions";
import MaintenanceItem from "./Item";
import Options from "./Options";
import SelectWithDialog from "./SelectWithDialog";
import { deleteGroup } from "../../services";
// import DateWithDialog from "./DateWithDialog";
// import { createItem } from "../../services";
const options = [
  "Maintenance Interval",
  // "Recurrence based on date",
  "Specified Recurrence",
];
const MaintenanceGroup = ({ item, index }) => {
  let ITEM = {
    plan: "",
    name: "",
    description: "",
    assignee: "",
  };
  // const [selectedIndex] = React.useState(1);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const { groups } = useSelector((state) => state["maintenancePlan"]);
  const formik = useFormik({
    initialValues: {
      type: item.type,
      name: item.name,
      description: item.description,
      display_order: item.display_order,
      // group_type: item.group_type,
      recurrence: item.recurrence,
    },
    validationSchema: Yup.object({
      name: Yup.string().trim().max(255).required("Name is required"),
      type: Yup.string().trim().max(255).required("Type is required"),
      // group_type: Yup.string().trim(),
      description: Yup.string().trim(),
      recurrence: Yup.string().trim(),
    }),
    onSubmit: () => {
      async function submit() {
        // console.log("formik", formik);
        const { name, type, description, recurrence } = formik.values;
        let attributes = { name, type, description, recurrence };
        try {
          console.log(attributes);
          // await onSubmit(attributes);
          // setOpen(true);
        } catch (error) {
          console.log(error);
          alert(error.message);
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });

  let params = useParams();
  const dispatch = useDispatch();
  const handleChangeGroup = (e, recurrence = false, recurrenceData = "") => {
    if (recurrence) {
      formik.setFieldValue("recurrence", recurrenceData);
      updateGroupRow({
        group: { ...formik.values, recurrence: recurrenceData },
        index,
      });
    } else {
      formik.handleChange(e);
      let { name, value } = e.target;
      // setMGroup({ ...group, [name]: value });
      updateGroupRow({ group: { ...formik.values, [name]: value }, index });
    }
  };
  const updateGroupRow = React.useMemo(
    () =>
      throttle((request) => {
        dispatch(setGroup(request.group, request.index));
      }, 200),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // const handleCreateItem = async (item, groupId) => {
  //   try {
  //     let attributes = ITEM;
  //     let planId = params.id;
  //     let payload = await createItem(attributes, planId, groupId);
  //     console.log(payload);
  //   } catch (error) {}
  // };
  return (
    <>
      <Card variant="outlined" sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <>
            <Grid item md={2.8} xs={12}>
              <div>
                <InputLabel>Type</InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  autoComplete="off"
                  error={Boolean(formik.touched.type && formik.errors.type)}
                  fullWidth
                  helperText={formik.touched.type && formik.errors.type}
                  placeholder="Type"
                  // margin="normal"
                  name="type"
                  onChange={(e) => handleChangeGroup(e)}
                  value={formik.values["type"]}
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={2.8} xs={12}>
              <div>
                <InputLabel>Name</InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  autoComplete="off"
                  error={Boolean(formik.touched.name && formik.errors.name)}
                  fullWidth
                  helperText={formik.touched.name && formik.errors.name}
                  placeholder="Type"
                  // margin="normal"
                  name="name"
                  onChange={(e) => handleChangeGroup(e)}
                  value={formik.values["name"]}
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={2.8} xs={12}>
              <div>
                <InputLabel>Description</InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  autoComplete="off"
                  error={Boolean(
                    formik.touched.description && formik.errors.description
                  )}
                  fullWidth
                  helperText={
                    formik.touched.description && formik.errors.description
                  }
                  placeholder="Type"
                  // margin="normal"
                  name="description"
                  onChange={(e) => handleChangeGroup(e)}
                  value={formik.values["description"]}
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={2.8} xs={12}>
              <div>
                <InputLabel>
                  Recurrence
                  <Options
                    options={options}
                    selectedIndex={selectedIndex}
                    setSelectedIndex={setSelectedIndex}
                  />
                </InputLabel>
                {selectedIndex === 0 ? (
                  <SelectWithDialog
                    // formik={formik}
                    // updateGroupRow={updateGroupRow}
                    setSelectedIndex={setSelectedIndex}
                    handleChangeGroup={handleChangeGroup}
                    // index={index}
                  />
                ) : (
                  //  : selectedIndex === 1 ? (
                  //   <DateWithDialog formik={formik} />
                  // )
                  <TextField
                    sx={{ mt: 1 }}
                    size="small"
                    autoComplete="off"
                    error={Boolean(
                      formik.touched.recurrence && formik.errors.recurrence
                    )}
                    fullWidth
                    helperText={
                      formik.touched.recurrence && formik.errors.recurrence
                    }
                    placeholder="Type"
                    // margin="normal"
                    name="recurrence"
                    onChange={(e) => handleChangeGroup(e)}
                    value={formik.values["recurrence"]}
                    variant="outlined"
                  />
                )}
              </div>
            </Grid>
            <Grid item md={0.8} xs={12}>
              <Tooltip title="Remove Group">
                <IconButton
                  sx={{ mt: { md: 3.5 } }}
                  onClick={async () => {
                    const newGroups = groups.filter(
                      (newGroup, i) => i !== index
                    );
                    dispatch(setGroups(newGroups));
                    if (item.system_id) {
                      // console.log(params.id, item.system_id);
                      try {
                        // let payload =
                        await deleteGroup(
                          params?.orgId,
                          params?.id,
                          item.system_id
                        );
                        // console.log("deleted", payload);
                      } catch (error) {
                        console.log(error);
                      }
                    }
                  }}
                >
                  <DeleteForever />
                </IconButton>
              </Tooltip>
            </Grid>
          </>
        </Grid>
        {/* Maintenance Items */}
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Maintenance Items
        </Typography>
        {item["items"]
          ? Array.from(item["items"]).map((task, itemIndex) => {
              return (
                <div key={itemIndex}>
                  <MaintenanceItem
                    task={{ ...task, display_order: itemIndex }}
                    taskIndex={itemIndex}
                    groupIndex={index}
                  />
                </div>
              );
            })
          : // <div>
            //   <MaintenanceItem task={ITEM} index={0} groupIndex={0} />
            // </div>
            ""}
        <Tooltip title="Add a New Maintenance Item">
          <IconButton
            color="primary"
            aria-label="add task"
            component="span"
            onClick={() => {
              return dispatch(
                setGroup(
                  {
                    ...formik.values,
                    items: item.items ? [...item.items, ITEM] : [ITEM],
                  },
                  index
                )
              );
            }}
          >
            <AddCircle />
          </IconButton>
        </Tooltip>
        {/* <Divider sx={{ mb: 1, mt: 2 }} /> */}
      </Card>
    </>
  );
};

export default React.memo(MaintenanceGroup);
